import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "../general/Modal/Modal";
import { IMPORTER_TRANSACTIONS_QUEUE } from "../../common/helpers/financialDocument";
import { ImporterContextProvider } from "./ImporterContextProvider";
import { Importer } from "./Importer";

interface Props {
    show: boolean;
    onHide: () => void;
}

export const ImporterModal: React.FC<Props> = ({ show, onHide }) => (
    <StandardModal fullscreen onHide={onHide} show={show}>
        <StandardModalHeader>Import Transactions</StandardModalHeader>
        <StandardModalBody>
            <ImporterContextProvider
                importerQueue={IMPORTER_TRANSACTIONS_QUEUE}
            >
                <Importer onHide={onHide} />
            </ImporterContextProvider>
        </StandardModalBody>
    </StandardModal>
);
